<template>
  <article class="">
    <h2 class="bold mb-5">Account</h2>

    <div class="mb-4 d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center">
        <img
          v-if="perfil.avatar === null"
          src="../../assets/images/image-preview.svg"
          class="rounded-circle mr-5"
        />
        <img
          v-else
          :src="perfil.avatar"
          class="rounded-circle mr-5"
          width="200px"
          height="150px"
        />
        <div>
          <h4 class="bold mb-2">{{ perfil.nombre }}</h4>
          <p class="m-0 text-muted">{{ perfil.apellido }}</p>
          <span
            :class="perfil.store === 2 ? 'bg-danger' : ' bg-primary'"
            class="badge badge-primary"
          >
            {{ perfil.store === 2 ? "Envios" : " Sendi" }}</span
          >
        </div>
      </div>
      <!-- <button type="button" class="btn btn-primary">Edit your avatar</button> -->
    </div>

    <div class="d-flex">
      <button
        type="button"
        :class="section === 1 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 1"
      >
        Perfil
      </button>
      <button
        type="button"
        :class="section === 2 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 2"
      >
        Saldo
      </button>
      <button
        type="button"
        :class="section === 3 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 3"
      >
        Pedidos
      </button>
      <button
        type="button"
        :class="section === 4 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 4"
      >
        Direcciones
      </button>
      <button
        type="button"
        :class="section === 5 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 5"
      >
        Credenciales
      </button>
      <button
        type="button"
        :class="section === 6 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 6"
      >
        Cotizaciones
      </button>
      <button
        v-if="perfil.store === 2"
        type="button"
        :class="section === 7 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 7"
      >
        Viajes
      </button>

      <button
        type="button"
        :class="section === 8 ? 'btn-primary' : 'btn-secondary'"
        class="btn mr-2"
        @click.prevent="section = 8"
      >
        Influencer
      </button>
    </div>
    <hr class="my-4" />
    <button
      type="button"
      class="btn d-block ml-auto mb-4 btn-primary"
      @click="openModal('modal-operacion')"
      v-if="section === 2"
    >
      <i class="fas fa-plus"></i>
      Agregar operación
    </button>
    <PerfilComponent
      :idUser="$route.params.idUser"
      :direction="direction"
      :perfil="perfil"
      v-if="section === 1"
    />
    <SaldoComponent v-if="section === 2" :idUser="$route.params.idUser" />
    <PedidoComponent v-if="section === 3" :idUser="$route.params.idUser" />
    <DirectionComponent v-if="section === 4" :perfil="perfil" :credential="credential" />
    <CredentialComponent
      :credential="credential"
      :idUser="$route.params.idUser"
      v-if="section === 5"
    />
    <CotizacionComponent v-if="section === 6" :idUser="$route.params.idUser" />
    <ViajeComponent
      v-if="section === 7"
      :idUser="$route.params.idUser"
      :travelSquad="travel_squad"
    />

    <button
      v-if="section === 8"
      @click.prevent="changeFlagInfluencer(influencerFlag === 1 ? 0 : 1)"
      class="d-block mb-4 ml-auto"
      :class="influencerFlag === 1 ? 'btn btn-danger' : 'btn btn-primary'"
    >
      {{ influencerFlag === 1 ? "Desactivar Influencer" : "Activar Influencer" }}
    </button>
    <CodigoComponent v-if="section === 8" :idUser="$route.params.idUser" />
    <!-- Modal agregar operacion -->
    <dialog id="modal-operacion">
      <article class="u-modal">
        <form @submit.prevent="addSaldoUser()" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Agregar operación</span>
            <span style="cursor: pointer" @click="closeModal('modal-operacion')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <div class="form-group">
            <label>Titulo de la operación</label>
            <div class="input-group">
              <input
                v-model="saldo.title"
                type="text"
                name=""
                class="form-control input"
                required
              />
            </div>
            <span class="text-danger" style="display: none"> </span>
          </div>
          <div class="form-group">
            <label>Descripción de la operación</label>
            <div class="input-group">
              <textarea
                type="text"
                name=""
                class="form-control input"
                rows="6"
                v-model="saldo.description"
                required
              ></textarea>
            </div>
            <span class="text-danger" style="display: none"> </span>
          </div>
          <div class="row">
            <div class="form-group col-8 pl-0">
              <label>Monto de la operacion</label>
              <div class="input-group">
                <input
                  v-model="saldo.monto"
                  type="number"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
              <span class="text-danger" style="display: none"> </span>
            </div>
            <!-- <div class="form-group col-4 pr-0">
              <label>Moneda</label>
              <div class="input-group">
                <select class="form-control">
                  <option selected="selected" value="1">PEN</option> 
                  <option value="2">USD</option> 
                </select>
              </div> 
            </div> -->
          </div>
          <button type="submit" class="btn btn-primary mx-auto d-block mt-4">
            Registrar operación
          </button>
        </form>
      </article>
    </dialog>
  </article>
</template>
<style>
dialog {
  border: none;
}
.u-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 10000;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.25);
  border: none;
  padding: 1rem;
}
.u-modal-content {
  padding: 2rem 1.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  background-color: #fff;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.25);
  min-width: 400px;
}
.wr-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.u-row {
  grid-template-columns: repeat(6, 1fr);
}
</style>
<script>
import axios from "axios";
import PerfilComponent from "@/components/component-user/PerfilComponent.vue";
import SaldoComponent from "@/components/component-user/SaldoComponent.vue";
import ViajeComponent from "@/components/component-user/ViajeComponent.vue";
import PedidoComponent from "@/components/component-user/PedidoComponent.vue";
import DirectionComponent from "@/components/component-user/DirectionComponent.vue";
import CredentialComponent from "@/components/component-user/CredentialComponent.vue";
import CotizacionComponent from "@/components/component-user/CotizacionComponent.vue";
import CodigoComponent from "@/components/component-user/CodigoComponent.vue";

export default {
  components: {
    PerfilComponent,
    SaldoComponent,
    ViajeComponent,
    PedidoComponent,
    DirectionComponent,
    CredentialComponent,
    CotizacionComponent,
    CodigoComponent,
  },
  data() {
    return {
      influencerFlag: null,
      saldo: {
        monto: null,
        title: null,
        description: null,
      },
      section: 1,
      perfil: {
        avatar: null,
        nombre: null,
        apellido: null,
        telefono: null,
        store: null,
      },
      credential: {
        codigo: null,
        documento: null,
        email: null,
        estado: null,
        dniPosterior: null,
        dniAnterior: null,
        varificado: null,
        statuAnterior: null,
        statuPosterior: null,
      },
      direction: {
        direction: null,
        piso: null,
        referencia: null,
        departamento: null,
        provincia: null,
        distrito: null,
      },
      travel_squad: null,
    };
  },
  mounted() {
    this.getUser();
  },
  methods: {
    changeFlagInfluencer(data) {
      let url =
        process.env.API_URL + "/api/admin/changeInfluencer/" + this.$route.params.idUser;
      axios
        .post(url, {
          influencerFlag: data,
        })
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          alert("Error al agregar cambiar el estado del influencer");
        });
    },
    addSaldoUser() {
      let url = process.env.API_URL + "/api/balance/add/" + this.$route.params.idUser;
      axios
        .post(url, {
          amount: this.saldo.monto,
          titleOper: this.saldo.title,
          descOper: this.saldo.description,
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al agregar saldo");
        });
    },
    getUser() {
      axios
        .get(process.env.API_URL + "/api/client/getById/" + this.$route.params.idUser)
        .then((response) => {
          const data = response.data.body.data.attributes;
          this.travel_squad = data.travel_squad;
          this.influencerFlag = data.influencer_flag;
          this.perfil.avatar =
            data.profile.attributes.userable.attributes.profile_image_url;
          this.perfil.nombre = data.profile.attributes.name;
          this.perfil.apellido = data.profile.attributes.surnames;
          this.perfil.telefono = data.profile.attributes.cellphone;
          this.perfil.store = data.profile.attributes.userable.attributes.store_id;
          this.credential.codigo = data.profile.attributes.userable.client_code;
          this.credential.documento = data.profile.attributes.document_number;
          this.credential.email = data.profile.attributes.userable.attributes.email;

          this.credential.varificado =
            data.profile.attributes.userable.attributes.validation;

          this.credential.dniPosterior =
            data.profile.attributes.userable.attributes.document_seal_url;
          this.credential.dniAnterior =
            data.profile.attributes.userable.attributes.document_face_url;

          this.credential.statuPosterior =
            data.profile.attributes.userable.attributes.document_seal_state;
          this.credential.statuAnterior =
            data.profile.attributes.userable.attributes.document_face_state;

          if (data.profile.attributes.userable.attributes.facebook_id) {
            this.credential.estado = "facebook";
          } else if (data.profile.attributes.userable.attributes.gmail_id) {
            this.credential.estado = "google";
          } else {
            this.credential.estado = "formulario";
          }

          if (data.addresses.length !== 0) {
            const dataUser = response.data.body.data;
            //direccion
            this.direction.direction =
              dataUser.attributes.addresses[0].attributes.address === null
                ? ""
                : dataUser.attributes.addresses[0].attributes.address;
            //piso
            this.direction.piso =
              dataUser.attributes.addresses[0].attributes.inner === null
                ? ""
                : dataUser.attributes.addresses[0].attributes.inner;
            //referencia
            this.direction.referencia =
              dataUser.attributes.addresses[0].attributes.reference === null
                ? ""
                : dataUser.attributes.addresses[0].attributes.reference;
            //departamento
            this.direction.departamento =
              dataUser.attributes.addresses[0].attributes.department === null
                ? ""
                : dataUser.attributes.addresses[0].attributes.department;
            //provincia
            this.direction.provincia =
              dataUser.attributes.addresses[0].attributes.city === null
                ? ""
                : dataUser.attributes.addresses[0].attributes.city;
            //distrito
            this.direction.distrito =
              dataUser.attributes.addresses[0].attributes.district === null
                ? ""
                : dataUser.attributes.addresses[0].attributes.district;
          }
        })
        .catch((error) => {
          console.log(error);
          alert("Error al obtener los dato del usuario");
        });
    },
    openModal(id) {
      const modal = document.getElementById(id);
      modal.showModal();
    },
    closeModal(id) {
      const modal = document.getElementById(id);
      modal.close();
    },
  },
};
</script>



// WEBPACK FOOTER //
// User.vue?53e0142e